import axios from "axios";

const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});

const CLAIM_URL =
  "https://api-frankfurt.rezcomm.com/sbook/ordr/orderref/claim";
const ORDER_REFERENCE_KEY = "orefwithoutprefix";
const ORDER_REFERENCE_BRAND_KEY = "orefwithoutprefix_brand";

function getStoredOrderReference() {
  const value = encryptStorage.getItem(ORDER_REFERENCE_KEY);
  return value === undefined || value === null ? "" : String(value).trim();
}

export async function claimOrderReference(brandId, { forceRefresh = false } = {}) {
  const brand_id = String(brandId || "").trim();
  if (!brand_id) {
    throw new Error("brand_id is required to claim an order reference");
  }

  if (!forceRefresh) {
    const existing = getStoredOrderReference();
    const existingBrand = String(
      encryptStorage.getItem(ORDER_REFERENCE_BRAND_KEY) || ""
    ).trim();
    if (existing && existingBrand === brand_id) {
      return existing;
    }
  }

  const response = await axios.post(CLAIM_URL, { brand_id }, {
    headers: { "Content-Type": "application/json" },
  });
  const claimed = String(response?.data?.orderreference_wtpre || "").trim();
  if (!claimed) {
    throw new Error("Claim API returned no orderreference_wtpre");
  }

  encryptStorage.setItem(ORDER_REFERENCE_KEY, claimed);
  encryptStorage.setItem(ORDER_REFERENCE_BRAND_KEY, brand_id);
  return claimed;
}
